import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "section-heading" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "Domains")
], -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "row mt-3 py-3 border-bottom border-top bg-light"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Pending Configuration")
], -1)
const _hoisted_6 = { class: "d-flex justify-content-center" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Pending Verification")
], -1)
const _hoisted_9 = { class: "d-flex justify-content-center" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Complete Domains")
], -1)
const _hoisted_12 = { class: "d-flex justify-content-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "Errors", -1)
const _hoisted_14 = { class: "row pt-3" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex mt-5 justify-content-center align-items-center"
}
const _hoisted_17 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-primary",
    role: "alert"
  }, " No CloudMailIn Errors ")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "w-100" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Error"),
    /*#__PURE__*/_createElementVNode("th", null, "Error Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col d-flex justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_FileDownload = _resolveComponent("FileDownload")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VPagination = _resolveComponent("VPagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FileUpload, { onGetUpdatedCount: _ctx.getDomainCounts }, null, 8, ["onGetUpdatedCount"]),
      _createVNode(_component_FileDownload)
    ]),
    (this.counts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString(this.counts?.awaitingConfiguration), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, _toDisplayString(this.counts?.awaitingVerification), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("p", _hoisted_12, _toDisplayString(this.counts?.completedDomains), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        (_ctx.loading && _ctx.error.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-primary",
                icon: ['fas', 'spinner'],
                size: "lg",
                spin: ""
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.error == '' && !_ctx.loading && _ctx.domains.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.domains.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("table", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domains, (d) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: d.id,
                      class: _normalizeClass(d.id === _ctx.selectedDomain.id ? 'selected-row' : ''),
                      onClick: _withModifiers(($event: any) => (_ctx.selectedDomain = { ...d }), ["prevent"])
                    }, [
                      _createElementVNode("td", null, _toDisplayString(d.name), 1),
                      _createElementVNode("td", null, _toDisplayString(d.error), 1),
                      _createElementVNode("td", null, _toDisplayString(d.errorType), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-warning mr-1",
                          onClick: _withModifiers(($event: any) => (_ctx.updateDomain(d.id)), ["prevent"])
                        }, " Re-Attempt ", 8, _hoisted_24),
                        _createElementVNode("button", {
                          class: "btn btn-danger",
                          onClick: _withModifiers(($event: any) => (_ctx.deleteDomain(d.id)), ["prevent"])
                        }, " Delete ", 8, _hoisted_25)
                      ])
                    ], 10, _hoisted_23))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_VPagination, {
                    pagination: _ctx.domainsPagination,
                    "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.domainsPagination) = $event)),
                    onPageChanged: _cache[1] || (_cache[1] = (page) => (_ctx.currentPage = page))
                  }, null, 8, ["pagination"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}